import MultiSwapInterface from "./MultiSwapInterface";

export default MultiSwapInterface;
